import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface PrimaryButtonProps extends ButtonProps {
  // Any additional props specific to PrimaryButton can be added here
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  sx,
  disabled,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      sx={{
        backgroundColor: disabled ? 'grey ' : 'black',
        color: 'white',
        boxShadow: 0,
        textTransform: 'none',
        borderRadius: '30px',
        '&:hover': {
          backgroundColor: disabled ? 'grey ' : 'black ',
          borderRadius: '30px',
          color: 'white',
        },
        '&.Mui-disabled': {
          color: 'white',
          opacity: 0.7,
          borderRadius: '30px',
        },
        ...sx // Allow overriding styles when needed
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;